import React, { createContext, useContext, useState, useEffect } from 'react';
import { getToken, setToken, removeToken, getUser, setUser, removeUser, apiRequest } from '../lib/utils';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUserState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = getToken();
      const storedUser = getUser();
      
      if (token && storedUser) {
        try {
          const userData = await apiRequest('/auth/me');
          setUserState(userData);
          setUser(userData);
        } catch (error) {
          logout();
        }
      }
      setLoading(false);
    };
    
    initAuth();
  }, []);

  const login = async (email, password) => {
    const response = await apiRequest('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    
    setToken(response.access_token);
    setUser(response.user);
    setUserState(response.user);
    
    return response.user;
  };

  const register = async (userData) => {
    const response = await apiRequest('/auth/register', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
    
    setToken(response.access_token);
    setUser(response.user);
    setUserState(response.user);
    
    return response.user;
  };

  const logout = () => {
    removeToken();
    removeUser();
    setUserState(null);
  };

  const isAdmin = () => user?.role === 'admin';
  const isClient = () => user?.role === 'client';
  const isProspect = () => user?.role === 'prospect';

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      login, 
      register, 
      logout, 
      isAdmin, 
      isClient, 
      isProspect,
      isAuthenticated: !!user 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
